import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Folder({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M21 8.99998V6.99998C21 5.88998 20.1 4.99998 19 4.99998H10.75M12.19 7.88998L10.79 5.09998C10.45 4.41998 9.74998 3.98998 8.99998 3.98998H4.97998V3.97998C3.86998 3.97998 2.97998 4.86998 2.97998 5.97998V17.98C2.97998 19.08 3.86998 19.98 4.97998 19.98H18.98C20.08 19.98 20.98 19.08 20.98 17.98V8.97998H13.96C13.2 8.97998 12.5 8.54998 12.17 7.86998L12.19 7.88998Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Folder;